import { BaseModel } from "./hateoas/base-model";

export class ReportEngineModel extends BaseModel {
  requestOperator?: number;
  reportTypeUuid?: string;
  parameter?: string;
}
